// extracted by mini-css-extract-plugin
export default {"loginForm":"style_loginForm__k7+Uw","errorMsg":"style_errorMsg__TIKOy","otpForm":"style_otpForm__hvCb-","forgotpasswordField":"style_forgotpasswordField__-Np79"};